import "./FAQ.module.css";
import Header from "@/reusable_sections/Header";
import Introduction from "./sections/Introduction";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import GetInTouch from "./sections/GetInTouch";
import Footer from "@/reusable_sections/Footer";
export default function FAQPage() {
  return <div>
      <Header />
      <Introduction />
      <FrequentlyAskedQuestions />
      <GetInTouch />
      <Footer />
    </div>;
}